import { Component, OnInit, Input } from '@angular/core';
import { Transition, StateService, RawParams } from '@uirouter/angular';
import * as moment from 'moment';
import * as _ from 'lodash';
import { UserPreferenceService } from '../user-preference/user-preference.service';
import { UserPreference } from '../user-preference/user-preference';
import { GetShowResponse } from '../FMAPI/get-show-response';
import { NewspaperRow } from './newspaper-row';
import { Show } from '../FMAPI/show';

@Component({
  selector: 'app-show-newspaper',
  templateUrl: './show-newspaper.component.html',
  styleUrls: ['./show-newspaper.component.css']
})
export class ShowNewspaperComponent implements OnInit {

  constructor(
    private Transition: Transition,
    private UserPrefSvc: UserPreferenceService,
    private StateSvc: StateService
  ) { }

  ShowDate: string;
  UserPreference: UserPreference;

  @Input() GetShowResponse: GetShowResponse;
  Milestones: NewspaperRow[];

  ngOnInit() {
    let favID = Number(this.Transition.params().favoriteid);

    // set showdate

    let showDateRaw = this.Transition.params().showdate;
    let todayStr = moment({ hour: 0 }).format('YYYY-MM-DD');
    this.ShowDate = !!showDateRaw ? showDateRaw : todayStr;

    // save last used favorite and view

    this.UserPreference = this.UserPrefSvc.Get();
    this.UserPreference.SelectedFavorite = favID;
    this.UserPreference.SelectedView = "newspaper";
    this.UserPrefSvc.Set(this.UserPreference);

    // turn off filter past if viewing past dates

    if (this.ShowDate < todayStr) {
      this.UserPreference.FilterPast = false;
    }

    this.PopulateTable();
  }

  PopulateTable() {
    // generate table data with showtime as row label and channel as column label

    const shows = this.GetShowResponse.Schedules
      .filter(show => {
        let now = moment().toDate();
        if (this.UserPreference.FilterPast) {
          return moment(show.Until).toDate() > now;
        } else {
          return true;
        }
      })
      .map(show => {
        // show.ShowTime = moment(show.ShowTime).toDate();
        // show.Until = moment(show.Until).toDate();
        show.Channel = this.GetShowResponse.Channels.find(c => c.Code == show.ChannelCode);
        return show;
      });

    this.Milestones = _(shows.map(s => s.ShowTime))
      .union(shows.map(s => s.Until))
      .sortBy(t => t)
      .map(t => {
        let row = new NewspaperRow();
        row.ShowTime = t;
        row.Cells = [];
        return row;
      })
      .value();

    this.Milestones.forEach(milestone => {
      this.GetShowResponse.Channels.forEach(channel => {
        const currentShow = shows.find(show => show.ChannelCode == channel.Code
          && show.ShowTime <= milestone.ShowTime && show.Until > milestone.ShowTime);

        if (!currentShow) {
          // if no show, insert blank cell

          let cell = new NewspaperRow.Cell();
          cell.Span = 1;
          milestone.Cells.push(cell);
        }
        else if (currentShow.ShowTime == milestone.ShowTime) {
          // if start time match

          let cell = new NewspaperRow.Cell();
          cell.Show = currentShow;

          let timeStart = this.Milestones.map(m => m.ShowTime).indexOf(currentShow.ShowTime);
          let timeEnd = this.Milestones.map(m => m.ShowTime).indexOf(currentShow.Until);

          cell.Span = timeEnd - timeStart;
          milestone.Cells.push(cell);
        }
        else {
          // has show but start time doesn't match: do nothing
        }
      });
    });
  }

  RefreshDetail() {
    let params: RawParams = {};
    params.favoriteid = this.UserPreference.SelectedFavorite;

    let todayStr = moment().format("YYYY-MM-DD");

    if (this.ShowDate != todayStr) {
      params.showdate = this.ShowDate;
    }

    this.StateSvc.go(this.StateSvc.current.name, params, { inherit: false });
  }

  ShouldBeVisible(show: Show) {
    if (!show) {
      return true;
    }
    let now = moment().toDate();
    return moment(show.Until).toDate() > now;
  }

  ChangeFilterPast() {
    let pref = this.UserPrefSvc.Get();
    pref.FilterPast = this.UserPreference.FilterPast;
    this.UserPrefSvc.Set(pref);

    this.PopulateTable();
  }

}



// WEBPACK FOOTER //
// D:/OTHERS/FirstmediaShowSchedule/src/app/show-newspaper/show-newspaper.component.ts